import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RETIRED_AUTH_PATHS } from '@/utils/retiredAuthPaths';
import Loader from 'wrapper/loader';
import Login from '@/pages/shared/auth/login/Login';
import MiraUnifiedLogin from '@/pages/shared/auth/login/MiraUnifiedLogin';
import AccountSelection from '@/pages/shared/auth/login/AccountSelection';
import NotFound from 'components/404';
import SessionExpire from 'wrapper/session-expire/SessionExpire';
import EmailVerified from 'wrapper/email-verified';
import OAuthCallback from '@/pages/shared/auth/oauth/OAuthCallback';
import CompanyOnboarding from '@/pages/b2b/onboarding/CompanyOnboarding';

const PlatformLogin = lazy(() => import('@/pages/platform/PlatformLogin'));
const SubdomainDemo = lazy(() => import('@/pages/shared/demo/SubdomainDemo'));

export const authRoutes = [
  {
    path: '/auth/callback',
    element: (
      <Suspense fallback={<Loader />}>
        <OAuthCallback />
      </Suspense>
    ),
  },
  {
    path: '/branch/auth/callback',
    element: (
      <Suspense fallback={<Loader />}>
        <OAuthCallback />
      </Suspense>
    ),
  },
  {
    path: '/onboard',
    element: (
      <Suspense fallback={<Loader />}>
        <CompanyOnboarding />
      </Suspense>
    ),
  },
  {
    path: '/platform/login',
    element: (
      <Suspense fallback={<Loader />}>
        <PlatformLogin />
      </Suspense>
    ),
  },
  {
    path: '/login',
    element: (
      <Suspense fallback={<Loader />}>
        <MiraUnifiedLogin initialUserType="buyer" />
      </Suspense>
    ),
  },
  {
    path: '/login/b2b',
    element: (
      <Suspense fallback={<Loader />}>
        <MiraUnifiedLogin initialUserType="specialist" />
      </Suspense>
    ),
  },
  // Retired auth screens. main.jsx already rewrites old links to /login before
  // the app renders; these cover an in-app navigation to one.
  ...RETIRED_AUTH_PATHS.map((path) => ({
    path,
    element: <Navigate to="/login" replace />,
  })),
  {
    path: '/',
    element: <Login />,
    children: [
      {
        index: true,  // Unified login defaults to buyer at '/'
        element: (
          <Suspense fallback={<Loader />}>
            <MiraUnifiedLogin initialUserType="buyer" />
          </Suspense>
        ),
      },
      {
        path: 'login/consumer',
        element: (
          <Suspense>
            <MiraUnifiedLogin initialUserType="buyer" />
          </Suspense>
        ),
      },
      {
        path: 'account-selection',
        element: (
          <Suspense>
            <AccountSelection />
          </Suspense>
        ),
      },
      {
        path: 'session-timeout',
        element: (
          <Suspense>
            <SessionExpire />
          </Suspense>
        ),
      },
      {
        path: 'result_page',
        element: (
          <Suspense>
            <EmailVerified />
          </Suspense>
        ),
      },
      // Developer-only demo; not part of the product.
      ...(import.meta.env.DEV
        ? [
            {
              path: 'demo/subdomain',
              element: (
                <Suspense fallback={<Loader />}>
                  <SubdomainDemo />
                </Suspense>
              ),
            },
          ]
        : []),
      {
        path: '*',
        element: (
          <Suspense>
            <NotFound />
          </Suspense>
        ),
      },
    ],
  },
];
